import React from 'react';
import '../styles/Sidebar.css';

const Sidebar = ({ user, currentPage, onPageChange, onLogout }) => {
  // 역할별 메뉴 구성
  const tutorMenus = [
    { id: 'home', icon: '🏠', label: '대시보드', path: '/dashboard' },
    { id: 'register', icon: '⏰', label: '희망시간 등록', path: '/schedule/register' },
    { id: 'profile', icon: '👤', label: '내 정보', path: '/profile' },
  ];

  const adminMenus = [
    { id: 'home', icon: '🏠', label: '대시보드', path: '/dashboard' },
    { id: 'all-schedule', icon: '🗓️', label: '스케줄 관리', path: '/schedule/all' },
    { id: 'tutor-manage', icon: '👨‍🏫', label: '튜터 관리', path: '/tutor/management' },
    { id: 'admin-manage', icon: '👨‍💼', label: '관리자 계정 관리', path: '/admin/management' },
    { id: 'profile', icon: '👤', label: '내 정보', path: '/profile' },
    { id: 'backup', icon: '💾', label: '데이터 관리', path: '/backup' },
  ];

  const menus = user.role === 'admin' ? adminMenus : tutorMenus;

  return (
    <div className="sidebar">
      {/* 로고 영역 */}
      <div className="sidebar-header">
        <img 
          src="/images/coderland_icon.png" 
          alt="코더랜드 로고" 
          className="sidebar-logo"
          onError={(e) => {e.target.style.display = 'none'}}
        />
        <h3>코더랜드</h3>
        <p className="sidebar-subtitle">스케줄러</p>
      </div>

      {/* 사용자 정보 */}
      <div className="sidebar-user">
        <div className="user-info">
          <p className="user-name">
            {user.name} {user.role === 'admin' ? '관리자' : '튜터'}
          </p>
        </div>
      </div>

      {/* 메뉴 리스트 */}
      <nav className="sidebar-nav">
        <ul className="menu-list">
          {menus.map((menu) => (
            <li key={menu.id} className="menu-item">
              <button
                className={`menu-button ${currentPage === menu.id ? 'active' : ''}`}
                onClick={() => onPageChange(menu.id, menu.path)}
              >
                <span className="menu-icon">{menu.icon}</span>
                <span className="menu-label">{menu.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* 로그아웃 버튼 */}
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={onLogout}>
          <span className="menu-icon">🚪</span>
          <span className="menu-label">로그아웃</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar; 